import * as zod from "zod";

/**
 * Returns None if the tenant does not have ScrapEye metadata configured.
 * @summary Get Scrap Eye Metadata
 */
export const GetScrapEyeMetadataParams = zod.object({
  tenant_name: zod.string(),
});

export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationTrackOutlinesItem0ItemMin = 0;
export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationTrackOutlinesItem0ItemMax = 1;

export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationTrackOutlinesItem1ItemMin = 0;
export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationTrackOutlinesItem1ItemMax = 1;

export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationTrackOutlinesMinOne = 3;

export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationCarPositionsItemOutlineItem0ItemMin = 0;
export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationCarPositionsItemOutlineItem0ItemMax = 1;

export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationCarPositionsItemOutlineItem1ItemMin = 0;
export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationCarPositionsItemOutlineItem1ItemMax = 1;

export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationCarPositionsItemOutlineMin = 3;

export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationCarPositionsItemCentre0ItemMin = 0;
export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationCarPositionsItemCentre0ItemMax = 1;

export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationCarPositionsItemCentre1ItemMin = 0;
export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationCarPositionsItemCentre1ItemMax = 1;

export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationMaskConfidenceThresholdMin = 0;
export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationMaskConfidenceThresholdMax = 1;

export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationMinimumCarPositionCoverageMin = 0;
export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationMinimumCarPositionCoverageMax = 1;

export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationMinimumMaskFractionInTrackMin = 0;
export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationMinimumMaskFractionInTrackMax = 1;

export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationMinimumTrackOverlapDifferenceMin = 0;
export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationMinimumTrackOverlapDifferenceMax = 1;

export const getScrapEyeMetadataResponseOneRailcarTrackingSpecsDefault = [];
export const getScrapEyeMetadataResponseOneReservationRecentWindowBufferHoursDefault = 0;
export const getScrapEyeMetadataResponseOneDropDetectionConfigSmoothingHorizonSecondsDefault = 30;
export const getScrapEyeMetadataResponseOneDropDetectionConfigSmoothingHorizonSecondsExclusiveMin = 0;

export const getScrapEyeMetadataResponseOneDropDetectionConfigRawCumulativeOneMaxDropWaitSecondsDefault = 6;
export const getScrapEyeMetadataResponseOneDropDetectionConfigRawCumulativeOneMaxDropWaitSecondsExclusiveMin = 0;

export const getScrapEyeMetadataResponseOneDropDetectionConfigRawCumulativeOneMaxPhysicalDropTonsDefault = 7;
export const getScrapEyeMetadataResponseOneDropDetectionConfigRawCumulativeOneMaxPhysicalDropTonsExclusiveMin = 0;

export const getScrapEyeMetadataResponseOneDropDetectionConfigRawCumulativeOneMaxPhysicalDecreaseTonsDefault = 7;
export const getScrapEyeMetadataResponseOneDropDetectionConfigRawCumulativeOneMaxPhysicalDecreaseTonsExclusiveMin = 0;

export const getScrapEyeMetadataResponseOneDropDetectionConfigCleanCumulativeOneMaxStepTonsDefault = 7;
export const getScrapEyeMetadataResponseOneDropDetectionConfigCleanCumulativeOneMaxStepTonsExclusiveMin = 0;

export const getScrapEyeMetadataResponseOneDropDetectionConfigCleanCumulativeOnePreStepPaddingSecondsDefault = 30;
export const getScrapEyeMetadataResponseOneDropDetectionConfigCleanCumulativeOnePreStepPaddingSecondsMin = 0;

export const getScrapEyeMetadataResponseOneDropDetectionConfigCleanCumulativeOnePostStepPaddingSecondsDefault = 30;
export const getScrapEyeMetadataResponseOneDropDetectionConfigCleanCumulativeOnePostStepPaddingSecondsMin = 0;

export const getScrapEyeMetadataResponseOneDropDetectionConfigPlateauOneSettleWindowSecondsExclusiveMin = 0;

export const getScrapEyeMetadataResponseOneDropDetectionConfigPlateauOneSettleToleranceTonsExclusiveMin = 0;

export const getScrapEyeMetadataResponseOneDropDetectionConfigPlateauOneSettleMinRunSecondsExclusiveMin = 0;

export const getScrapEyeMetadataResponseOneDropDetectionConfigPlateauOnePlateauMergeTonsMin = 0;

export const getScrapEyeMetadataResponseOneDropDetectionConfigPlateauOneMaxStepTonsExclusiveMin = 0;

export const getScrapEyeMetadataResponseOneDropDetectionConfigPlateauOneStepEdgeToleranceSecondsMin = 0;

export const getScrapEyeMetadataResponseOneDropDetectionConfigPlateauOneContextWideningMinutesMin = 0;

export const getScrapEyeMetadataResponseOneDropDetectionConfigPlateauOneMaxFfillSecondsExclusiveMin = 0;

export const getScrapEyeMetadataResponseOneBucketCycleConfigEmptyStatusMinStepsDefault = 5;
export const getScrapEyeMetadataResponseOneBucketCycleConfigEmptyStatusWithLoadMinStepsDefault = 60;
export const getScrapEyeMetadataResponseOneBucketCycleConfigEmptyStatusWeightThresholdTonsDefault = 5;
export const getScrapEyeMetadataResponseOneBucketCycleConfigZeroMassReadyMinStepsDefault = 20;
export const getScrapEyeMetadataResponseOneBucketCycleConfigLoadingDetectionWindowStepsDefault = 5;
export const getScrapEyeMetadataResponseOneBucketCycleConfigHeatStartFirstBucketGraceMinutesDefault = 10;
export const getScrapEyeMetadataResponseOneBucketCycleConfigLongHeatFirstChargeToTapMinMinutesDefault = 45;
export const getScrapEyeMetadataResponseOneBucketCycleConfigMaxCycleMergeGapSecondsDefault = 5;
export const getScrapEyeMetadataResponseOneBucketCycleConfigMaxBucketsDefault = 3;
export const getScrapEyeMetadataResponseOneLabelReviewConfigWarningsConfidenceThresholdsEventDefault = 0.5;
export const getScrapEyeMetadataResponseOneLabelReviewConfigWarningsConfidenceThresholdsMaterialDefault = 0.5;
export const getScrapEyeMetadataResponseOneLabelReviewConfigWarningsConfidenceThresholdsAreaDefault = 0.5;
export const getScrapEyeMetadataResponseOneLabelReviewConfigWarningsDefaultFlagRulesEventConfidenceThresholdOneMin = 0;

export const getScrapEyeMetadataResponseOneLabelReviewConfigWarningsDefaultFlagRulesMaterialConfidenceThresholdOneMin = 0;
export const getScrapEyeMetadataResponseOneLabelReviewConfigWarningsDefaultFlagRulesMaterialConfidenceThresholdOneMax = 1;

export const getScrapEyeMetadataResponseOneLabelReviewConfigWarningsDefaultFlagRulesAreaConfidenceThresholdOneMin = 0;
export const getScrapEyeMetadataResponseOneLabelReviewConfigWarningsDefaultFlagRulesAreaConfidenceThresholdOneMax = 1;

export const getScrapEyeMetadataResponseOneLabelReviewConfigWarningsDefaultFlagRulesMassOutlierQuantileOneExclusiveMin = 0;
export const getScrapEyeMetadataResponseOneLabelReviewConfigWarningsDefaultFlagRulesMassOutlierQuantileOneExclusiveMax = 0.5;

export const getScrapEyeMetadataResponseOneLabelReviewConfigMassCandidateSharingDefault = `exclusive`;
export const getScrapEyeMetadataResponseOneLabelReviewConfigMassEventFallbackPaddingSecondsDefault = 0;
export const getScrapEyeMetadataResponseOneLabelReviewConfigMaxAssignedMassTonsOneExclusiveMin = 0;

export const getScrapEyeMetadataResponseOneLabelReviewConfigMergeEventsSeparatedByGapSecondsDefault = 20;
export const getScrapEyeMetadataResponseOneLabelReviewConfigMinimumIntersectionOverUnionDefault = 0.5;
export const getScrapEyeMetadataResponseOneLabelReviewConfigAssignmentExpirySecondsDefault = 14400;
export const getScrapEyeMetadataResponseOneLabelReviewConfigTargetReviewPeriodFractionExclusiveMin = 0;
export const getScrapEyeMetadataResponseOneLabelReviewConfigTargetReviewPeriodFractionMax = 1;

export const getScrapEyeMetadataResponseOneLabelReviewConfigRandomReviewPeriodFractionByLocationMinOne = 0;
export const getScrapEyeMetadataResponseOneLabelReviewConfigRandomReviewPeriodFractionByLocationMaxOne = 1;

export const getScrapEyeMetadataResponseOneLayeringComplianceConfigOrderWeightDefault = 0.5;
export const getScrapEyeMetadataResponseOneLayeringComplianceConfigOrderWeightMin = 0;
export const getScrapEyeMetadataResponseOneLayeringComplianceConfigOrderWeightMax = 1;

export const getScrapEyeMetadataResponseOneLayeringComplianceConfigPairsDefault =
  [];
export const getScrapEyeMetadataResponseOneLayeringComplianceConfigUnknownLayerHandlingDefault = `distinct_material`;

export const GetScrapEyeMetadataResponse = zod.union([
  zod
    .object({
      railcar_tracking_specs: zod
        .array(
          zod.object({
            configuration: zod.object({
              location: zod.string().min(1),
              angle: zod.string().min(1),
              track_outlines: zod.record(
                zod.string(),
                zod
                  .array(
                    zod.tuple([
                      zod
                        .number()
                        .min(
                          getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationTrackOutlinesItem0ItemMin
                        )
                        .max(
                          getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationTrackOutlinesItem0ItemMax
                        ),
                      zod
                        .number()
                        .min(
                          getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationTrackOutlinesItem1ItemMin
                        )
                        .max(
                          getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationTrackOutlinesItem1ItemMax
                        ),
                    ])
                  )
                  .min(
                    getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationTrackOutlinesMinOne
                  )
              ),
              car_positions: zod
                .array(
                  zod.object({
                    area: zod.string(),
                    track: zod.string(),
                    position: zod.int().min(1),
                    outline: zod
                      .array(
                        zod.tuple([
                          zod
                            .number()
                            .min(
                              getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationCarPositionsItemOutlineItem0ItemMin
                            )
                            .max(
                              getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationCarPositionsItemOutlineItem0ItemMax
                            ),
                          zod
                            .number()
                            .min(
                              getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationCarPositionsItemOutlineItem1ItemMin
                            )
                            .max(
                              getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationCarPositionsItemOutlineItem1ItemMax
                            ),
                        ])
                      )
                      .min(
                        getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationCarPositionsItemOutlineMin
                      ),
                    centre: zod.tuple([
                      zod
                        .number()
                        .min(
                          getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationCarPositionsItemCentre0ItemMin
                        )
                        .max(
                          getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationCarPositionsItemCentre0ItemMax
                        ),
                      zod
                        .number()
                        .min(
                          getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationCarPositionsItemCentre1ItemMin
                        )
                        .max(
                          getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationCarPositionsItemCentre1ItemMax
                        ),
                    ]),
                  })
                )
                .min(1),
              mask_confidence_threshold: zod
                .number()
                .min(
                  getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationMaskConfidenceThresholdMin
                )
                .max(
                  getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationMaskConfidenceThresholdMax
                ),
              minimum_car_position_coverage: zod
                .number()
                .min(
                  getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationMinimumCarPositionCoverageMin
                )
                .max(
                  getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationMinimumCarPositionCoverageMax
                ),
              minimum_mask_fraction_in_track: zod
                .number()
                .min(
                  getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationMinimumMaskFractionInTrackMin
                )
                .max(
                  getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationMinimumMaskFractionInTrackMax
                ),
              minimum_track_overlap_difference: zod
                .number()
                .min(
                  getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationMinimumTrackOverlapDifferenceMin
                )
                .max(
                  getScrapEyeMetadataResponseOneRailcarTrackingSpecsItemConfigurationMinimumTrackOverlapDifferenceMax
                ),
              consecutive_frames_to_confirm: zod.int().min(1),
            }),
            first_window_start: zod.iso.datetime({ offset: true }),
            run_until: zod.union([
              zod.iso.datetime({ offset: true }),
              zod.null(),
            ]),
          })
        )
        .default(getScrapEyeMetadataResponseOneRailcarTrackingSpecsDefault),
      available_areas: zod.array(zod.string()),
      default_areas: zod.object({
        lift: zod.union([zod.string(), zod.null()]),
        drop: zod.union([zod.string(), zod.null()]),
        flag: zod.union([zod.string(), zod.null()]),
      }),
      drop_areas: zod.array(zod.string()),
      scale_weight_areas: zod.array(zod.string()),
      scale_weight_source: zod.union([
        zod
          .enum(["bucket", "crane"])
          .describe(
            "How mass-timeseries areas map onto drop records.\n\n- BUCKET: MassDataPoint.area matches the consumption area (to_area on drops).\n- CRANE: MassDataPoint.area matches the crane location (location_name on drops)."
          ),
        zod.null(),
      ]),
      required_angles: zod.array(zod.string()),
      gap_tolerance_seconds: zod
        .int()
        .describe("Footage dropouts up to this long still count as covered."),
      reservation: zod.object({
        chunk_seconds: zod
          .int()
          .describe(
            "Length in seconds of every labelling period and review period. Do not change it after the tenant has periods, because queries use it to bound period starts."
          ),
        grid_start: zod.iso.datetime({ offset: true }),
        default_reserve_from: zod.union([
          zod.iso.datetime({ offset: true }),
          zod.null(),
        ]),
        default_label_coverage_priority: zod.enum([
          "breadth",
          "depth",
          "last_calendar_day_then_breadth",
          "last_calendar_day_then_depth",
          "recent_breadth",
          "recent_depth",
        ]),
        recent_window_buffer_hours: zod
          .int()
          .default(
            getScrapEyeMetadataResponseOneReservationRecentWindowBufferHoursDefault
          ),
      }),
      extra_data: zod.array(
        zod.enum([
          "mass_data",
          "bucket_loading_windows",
          "railcar_slot_materials",
        ])
      ),
      area_hotkeys: zod.record(zod.string(), zod.string()),
      default_area_materials: zod.record(zod.string(), zod.string()),
      max_consecutive_drops: zod.int(),
      max_consecutive_lifts: zod.int(),
      target_num_labellers: zod.int(),
      maximum_num_labellers: zod.int(),
      drop_detection_config: zod.object({
        detector: zod
          .enum(["raw_cumulative", "clean_cumulative", "plateau_steps"])
          .describe("How candidate masses are measured from the scale."),
        smoothing_horizon_seconds: zod
          .int()
          .gt(
            getScrapEyeMetadataResponseOneDropDetectionConfigSmoothingHorizonSecondsExclusiveMin
          )
          .default(
            getScrapEyeMetadataResponseOneDropDetectionConfigSmoothingHorizonSecondsDefault
          )
          .describe(
            "Extra signal read either side of every request, whichever detector measures it."
          ),
        raw_cumulative: zod
          .union([
            zod.object({
              max_drop_wait_seconds: zod
                .int()
                .gt(
                  getScrapEyeMetadataResponseOneDropDetectionConfigRawCumulativeOneMaxDropWaitSecondsExclusiveMin
                )
                .default(
                  getScrapEyeMetadataResponseOneDropDetectionConfigRawCumulativeOneMaxDropWaitSecondsDefault
                )
                .describe(
                  "How long a pause may last before it ends the drop it sits in."
                ),
              max_physical_drop_tons: zod
                .number()
                .gt(
                  getScrapEyeMetadataResponseOneDropDetectionConfigRawCumulativeOneMaxPhysicalDropTonsExclusiveMin
                )
                .default(
                  getScrapEyeMetadataResponseOneDropDetectionConfigRawCumulativeOneMaxPhysicalDropTonsDefault
                )
                .describe("The largest rise one second of feed can be."),
              max_physical_decrease_tons: zod
                .number()
                .gt(
                  getScrapEyeMetadataResponseOneDropDetectionConfigRawCumulativeOneMaxPhysicalDecreaseTonsExclusiveMin
                )
                .default(
                  getScrapEyeMetadataResponseOneDropDetectionConfigRawCumulativeOneMaxPhysicalDecreaseTonsDefault
                )
                .describe("The largest fall one second of feed can be."),
            }),
            zod.null(),
          ])
          .optional(),
        clean_cumulative: zod
          .union([
            zod.object({
              max_step_tons: zod
                .number()
                .gt(
                  getScrapEyeMetadataResponseOneDropDetectionConfigCleanCumulativeOneMaxStepTonsExclusiveMin
                )
                .default(
                  getScrapEyeMetadataResponseOneDropDetectionConfigCleanCumulativeOneMaxStepTonsDefault
                )
                .describe(
                  "Steps larger than this are more than one drop, and are excluded rather than measured."
                ),
              pre_step_padding_seconds: zod
                .int()
                .min(
                  getScrapEyeMetadataResponseOneDropDetectionConfigCleanCumulativeOnePreStepPaddingSecondsMin
                )
                .default(
                  getScrapEyeMetadataResponseOneDropDetectionConfigCleanCumulativeOnePreStepPaddingSecondsDefault
                )
                .describe(
                  "Widen each measured step by this much at its start."
                ),
              post_step_padding_seconds: zod
                .int()
                .min(
                  getScrapEyeMetadataResponseOneDropDetectionConfigCleanCumulativeOnePostStepPaddingSecondsMin
                )
                .default(
                  getScrapEyeMetadataResponseOneDropDetectionConfigCleanCumulativeOnePostStepPaddingSecondsDefault
                )
                .describe("Widen each measured step by this much at its end."),
            }),
            zod.null(),
          ])
          .optional(),
        plateau: zod
          .union([
            zod.object({
              plausible_reading_range_tons: zod
                .tuple([zod.number(), zod.number()])
                .describe(
                  "Readings outside this range are not real weights. Set the floor above the scale's empty reading, so a lifted bucket is not read as a loaded one."
                ),
              settle_window_seconds: zod
                .int()
                .gt(
                  getScrapEyeMetadataResponseOneDropDetectionConfigPlateauOneSettleWindowSecondsExclusiveMin
                )
                .describe(
                  "Length of the window the scale is judged steady over."
                ),
              settle_tolerance_tons: zod
                .number()
                .gt(
                  getScrapEyeMetadataResponseOneDropDetectionConfigPlateauOneSettleToleranceTonsExclusiveMin
                )
                .describe(
                  "How far the scale may wander and still count as steady. This also sets the slowest loading that can be measured: material arriving more slowly than this per settle_window_seconds reads as drift."
                ),
              settle_min_run_seconds: zod
                .int()
                .gt(
                  getScrapEyeMetadataResponseOneDropDetectionConfigPlateauOneSettleMinRunSecondsExclusiveMin
                )
                .describe(
                  "How long the scale must stay steady before its level counts, on top of settle_window_seconds. The window is centred, so two drops either side of a shorter pause are measured as one."
                ),
              plateau_merge_tons: zod
                .number()
                .min(
                  getScrapEyeMetadataResponseOneDropDetectionConfigPlateauOnePlateauMergeTonsMin
                )
                .describe(
                  "Two steady levels this close apart are one level split by a jolt, not two separated by a drop. Keep it at or below the settle tolerance, so only jolts are merged."
                ),
              max_step_tons: zod
                .number()
                .gt(
                  getScrapEyeMetadataResponseOneDropDetectionConfigPlateauOneMaxStepTonsExclusiveMin
                )
                .describe(
                  "Steps larger than this are more than one drop, and are excluded rather than measured."
                ),
              step_edge_tolerance_seconds: zod
                .int()
                .min(
                  getScrapEyeMetadataResponseOneDropDetectionConfigPlateauOneStepEdgeToleranceSecondsMin
                )
                .describe(
                  "Widen each measured step by this much at both ends, so a drop labelled just before or after the scale moved still lines up with the step."
                ),
              context_widening_minutes: zod
                .int()
                .min(
                  getScrapEyeMetadataResponseOneDropDetectionConfigPlateauOneContextWideningMinutesMin
                )
                .describe(
                  "Extra signal read either side of a request, so a drop near its edge still has a settled reading on both sides."
                ),
              max_ffill_seconds: zod
                .int()
                .gt(
                  getScrapEyeMetadataResponseOneDropDetectionConfigPlateauOneMaxFfillSecondsExclusiveMin
                )
                .describe(
                  "Longest silence in the feed held at its last reading; longer silences count as missing signal."
                ),
            }),
            zod.null(),
          ])
          .optional(),
      }),
      bucket_cycle_config: zod.object({
        empty_status_min_steps: zod
          .int()
          .default(
            getScrapEyeMetadataResponseOneBucketCycleConfigEmptyStatusMinStepsDefault
          ),
        empty_status_with_load_min_steps: zod
          .int()
          .default(
            getScrapEyeMetadataResponseOneBucketCycleConfigEmptyStatusWithLoadMinStepsDefault
          ),
        empty_status_weight_threshold_tons: zod
          .number()
          .default(
            getScrapEyeMetadataResponseOneBucketCycleConfigEmptyStatusWeightThresholdTonsDefault
          ),
        zero_mass_ready_min_steps: zod
          .int()
          .default(
            getScrapEyeMetadataResponseOneBucketCycleConfigZeroMassReadyMinStepsDefault
          ),
        loading_detection_window_steps: zod
          .int()
          .default(
            getScrapEyeMetadataResponseOneBucketCycleConfigLoadingDetectionWindowStepsDefault
          ),
        heat_start_first_bucket_grace_minutes: zod
          .int()
          .default(
            getScrapEyeMetadataResponseOneBucketCycleConfigHeatStartFirstBucketGraceMinutesDefault
          ),
        long_heat_first_charge_to_tap_min_minutes: zod
          .int()
          .default(
            getScrapEyeMetadataResponseOneBucketCycleConfigLongHeatFirstChargeToTapMinMinutesDefault
          ),
        max_cycle_merge_gap_seconds: zod
          .int()
          .default(
            getScrapEyeMetadataResponseOneBucketCycleConfigMaxCycleMergeGapSecondsDefault
          ),
        max_buckets: zod
          .int()
          .default(
            getScrapEyeMetadataResponseOneBucketCycleConfigMaxBucketsDefault
          ),
      }),
      label_review_config: zod.object({
        warnings: zod.object({
          mass_event_types: zod
            .array(zod.enum(["lift", "drop", "flag"]))
            .optional(),
          confidence_thresholds: zod.object({
            event: zod
              .number()
              .default(
                getScrapEyeMetadataResponseOneLabelReviewConfigWarningsConfidenceThresholdsEventDefault
              ),
            material: zod
              .number()
              .default(
                getScrapEyeMetadataResponseOneLabelReviewConfigWarningsConfidenceThresholdsMaterialDefault
              ),
            area: zod
              .number()
              .default(
                getScrapEyeMetadataResponseOneLabelReviewConfigWarningsConfidenceThresholdsAreaDefault
              ),
          }),
          default_flag_rules: zod
            .object({
              reasons: zod
                .array(
                  zod.enum([
                    "too_few_examples",
                    "missing_labels",
                    "incompatible_labels",
                    "incompatible_timing",
                    "ambiguous_matching",
                    "invalid_sequence",
                    "comment",
                    "false_positive",
                    "false_negative",
                    "low_confidence_event",
                    "low_confidence_material",
                    "low_confidence_area",
                    "likely_error",
                    "confusable_material",
                    "unplanned_material",
                    "railcar_disagreement",
                    "mass_outlier",
                    "duplicate_mass",
                  ])
                )
                .describe(
                  "Targeted-review reasons that can flag the model's events."
                ),
              event_confidence_threshold: zod.union([
                zod
                  .number()
                  .min(
                    getScrapEyeMetadataResponseOneLabelReviewConfigWarningsDefaultFlagRulesEventConfidenceThresholdOneMin
                  ),
                zod.null(),
              ]),
              material_confidence_threshold: zod.union([
                zod
                  .number()
                  .min(
                    getScrapEyeMetadataResponseOneLabelReviewConfigWarningsDefaultFlagRulesMaterialConfidenceThresholdOneMin
                  )
                  .max(
                    getScrapEyeMetadataResponseOneLabelReviewConfigWarningsDefaultFlagRulesMaterialConfidenceThresholdOneMax
                  ),
                zod.null(),
              ]),
              area_confidence_threshold: zod.union([
                zod
                  .number()
                  .min(
                    getScrapEyeMetadataResponseOneLabelReviewConfigWarningsDefaultFlagRulesAreaConfidenceThresholdOneMin
                  )
                  .max(
                    getScrapEyeMetadataResponseOneLabelReviewConfigWarningsDefaultFlagRulesAreaConfidenceThresholdOneMax
                  ),
                zod.null(),
              ]),
              mass_outlier_quantile: zod.union([
                zod
                  .number()
                  .gt(
                    getScrapEyeMetadataResponseOneLabelReviewConfigWarningsDefaultFlagRulesMassOutlierQuantileOneExclusiveMin
                  )
                  .lt(
                    getScrapEyeMetadataResponseOneLabelReviewConfigWarningsDefaultFlagRulesMassOutlierQuantileOneExclusiveMax
                  ),
                zod.null(),
              ]),
              confusable_materials: zod
                .array(zod.string())
                .describe(
                  "Material names that are rare and easily confused with one another."
                ),
              never_planned_materials: zod
                .array(zod.string())
                .describe(
                  "Material names that never appear in a planned recipe."
                ),
            })
            .describe("The site's default targeted-review flag rules."),
        }),
        mass_candidate_sharing: zod
          .enum(["exclusive", "shared"])
          .default(
            getScrapEyeMetadataResponseOneLabelReviewConfigMassCandidateSharingDefault
          )
          .describe(
            "What happens when one measured mass covers several drops. EXCLUSIVE gives it all to the first drop and leaves the rest with no mass; SHARED splits it between them."
          ),
        mass_event_fallback_padding_seconds: zod
          .number()
          .default(
            getScrapEyeMetadataResponseOneLabelReviewConfigMassEventFallbackPaddingSecondsDefault
          ),
        max_assigned_mass_tons: zod
          .union([
            zod
              .number()
              .gt(
                getScrapEyeMetadataResponseOneLabelReviewConfigMaxAssignedMassTonsOneExclusiveMin
              ),
            zod.null(),
          ])
          .describe(
            "The heaviest total one event may be given from the scale, however many measured steps it is built from."
          ),
        merge_events_separated_by_gap_seconds: zod
          .number()
          .default(
            getScrapEyeMetadataResponseOneLabelReviewConfigMergeEventsSeparatedByGapSecondsDefault
          ),
        minimum_intersection_over_union: zod
          .number()
          .default(
            getScrapEyeMetadataResponseOneLabelReviewConfigMinimumIntersectionOverUnionDefault
          ),
        assignment_expiry_seconds: zod
          .int()
          .default(
            getScrapEyeMetadataResponseOneLabelReviewConfigAssignmentExpirySecondsDefault
          ),
        default_timeline_exclusions: zod
          .array(
            zod.object({
              labeller_type: zod.enum(["human", "model"]),
              feature: zod.enum(["material", "timing", "all"]),
              model_status: zod.union([
                zod.enum(["unused", "passive", "active"]),
                zod.null(),
              ]),
            })
          )
          .optional(),
        target_review_period_fraction: zod
          .number()
          .gt(
            getScrapEyeMetadataResponseOneLabelReviewConfigTargetReviewPeriodFractionExclusiveMin
          )
          .max(
            getScrapEyeMetadataResponseOneLabelReviewConfigTargetReviewPeriodFractionMax
          )
          .describe(
            "Fraction of review periods the site intends to review. Below 1, the incomplete-periods alerts count only flagged periods."
          ),
        random_review_period_fraction_by_location: zod
          .record(
            zod.string(),
            zod
              .number()
              .min(
                getScrapEyeMetadataResponseOneLabelReviewConfigRandomReviewPeriodFractionByLocationMinOne
              )
              .max(
                getScrapEyeMetadataResponseOneLabelReviewConfigRandomReviewPeriodFractionByLocationMaxOne
              )
          )
          .describe(
            "Random review fractions keyed by labelling installation location name. Periods are sampled independently of the flagging rules. Locations without an entry send no periods for random review."
          ),
        evaluation_dataset_id: zod
          .union([zod.string(), zod.null()])
          .describe(
            "Dataset in `scrapeye.dataset` whose test split expected model performance is measured on. The split has to be verified through regardless of which periods the targeted-review rule flagged, and held out from the training data of every model reported for the site. Null leaves the site without an expected-performance estimate. Naming a dataset also schedules every model reported for the site over that dataset's test split."
          ),
        pooled_location_groups: zod
          .array(zod.array(zod.string()))
          .describe(
            "Sets of locations whose model performance is reported together, for locations interchangeable enough that one figure describes them all. A location named in no set is reported on its own. A set is reported as one model whichever version each of its locations is running."
          ),
      }),
      mass_area_matching: zod.boolean(),
      mass_event_matching: zod.enum(["on_drop", "on_lift"]),
      scale_reading_lookup: zod
        .enum(["nearest", "at_or_before"])
        .describe(
          "How the review charts read a weight off the scale series at an instant.\n\n- NEAREST: whichever reading is closest, either side.\n- AT_OR_BEFORE: the last reading at or before the instant."
        ),
      label_recording_playback_rate: zod.number(),
      layering_compliance_config: zod
        .object({
          order_weight: zod
            .number()
            .min(
              getScrapEyeMetadataResponseOneLayeringComplianceConfigOrderWeightMin
            )
            .max(
              getScrapEyeMetadataResponseOneLayeringComplianceConfigOrderWeightMax
            )
            .default(
              getScrapEyeMetadataResponseOneLayeringComplianceConfigOrderWeightDefault
            )
            .describe(
              "Weight in [0, 1] traded between the layer-order penalty and the layer-mass penalty when scoring layering compliance. 0.5 is balanced."
            ),
          pairs: zod
            .array(
              zod
                .object({
                  target_mix_source: zod
                    .string()
                    .describe(
                      "The reference mix source (e.g. 'plannedSource')."
                    ),
                  comparison_mix_source: zod
                    .string()
                    .describe(
                      "The mix source scored against the target (e.g. 'ScrapEye')."
                    ),
                })
                .describe(
                  "A pair of mix sources whose basket layerings are compared for compliance."
                )
            )
            .default(
              getScrapEyeMetadataResponseOneLayeringComplianceConfigPairsDefault
            )
            .describe(
              "Mix-source pairs to score against each other. Empty means layering compliance is not computed for the tenant."
            ),
          unknown_layer_handling: zod
            .enum(["distinct_material", "wildcard"])
            .default(
              getScrapEyeMetadataResponseOneLayeringComplianceConfigUnknownLayerHandlingDefault
            )
            .describe(
              "How the ScrapEye 'unknown' layer is scored. WILDCARD aligns it to any material with no order penalty and may merge it into an adjacent layer for free; DISTINCT_MATERIAL scores it as ordinary."
            ),
        })
        .describe(
          "Per-tenant tuning for the basket layering compliance score."
        ),
    })
    .describe("ScrapEye configuration metadata for a tenant."),
  zod.null(),
]);
